export const data = [
  {
    text: 'Я люблю посещать ваше кафе. Вы готовите самое вкусное мороженое в городе! Кроме того, у вас красивая подача, уютная атмосфера и вежливый персонал.',
    name: 'Анюта, Тамбов',
  },
  {
    text: 'Каждый день мы приходим к вам с друзьями после занятий в колледже. Мы любим ваше мороженое и непринужденную атмосферу!',
    name: 'Борис, Москва',
  },
  {
    text: 'Я люблю есть фруктовое мороженое в жаркий день. У вас всегда вкусно. Всем знакомым рекомендую ваше кафе.',
    name: 'Сергей, Тамбов',
  },
  {
    text: 'Мороженое - моя страсть! Обожаю ваше шоколадно-ореховое мороженое! И мне очень нравится отличный сервис - всегда обслуживают вежливо и быстро!',
    name: 'Диана, Калуга',
  },
];
